module.exports = __webpack_public_path__ + "img/swiper.e19d5ee4.jpg";